<script>
  import RelatorioLancamentosPagamentos from './RelatorioLancamentosPagamentos.vue';
  import RelatorioRubricasSintetico from '~modulos/relatorio/componentes/Rubricas/Sintetico.vue';
  import transparenciaServico from '../../servico';

  export default {
    name: 'DetalharProjeto',
    components: { RelatorioLancamentosPagamentos, RelatorioRubricasSintetico },
    data() {
      return {
        projeto: {
          idProjeto: null,
          nomeProjeto: null,
          objetivo: null,
          clausulaConfidencialLei8958: null,
          unidade: null,
          departamento: null,
          dataInicioVigencia: null,
          dataTerminoVigencia: null,
          dataInicio: null,
          dataTermino: null,
          volumeTotalRecursos: null,
          nomeCoordenador: null,
          nrProcesso: null,
          nrProcessoInst: null,
          nomeOrgaoFinanciador: null,
          perpetuaClausulaConfidencialLei8958: null,
          arquivosClausulaConfidencialLei8958: null,
          relatoriosClausulaConfidencialLei8958: null,
          dataLimiteClausulaConfidencialLei8958: null,
          adeptoLei13019: null,
        },
        tipoRelatorio: null,
        relatorio: null,
        relatorioAcompanhamentoProjeto: [],
        orgaosFinaciadoresProjeto: [],
        arquivos: [],
        RELATORIO_LANCAMENTOS:  '0',
        RELATORIO_PAGAMENTO_PESSOA_FISICA:  '1',
        RELATORIO_PAGAMENTO_PESSOA_JURIDICA:  '2',
        RELATORIO_PAGAMENTO_AGENTE:  '3',
        RELATORIO_PAGAMENTO_ALUNO:  '4',
        RELATORIO_PAGAMENTO_CLT:  '5',
        RELATORIO_RUBRICAS:  '6',
        RELATORIO_COMPRAS_LICITACOES: '7',
        RELATORIO_ACOMPANHAMENTO_PROJETO: '8',
      }
    },
    methods: {
      carregarProjeto(id) {
        return transparenciaServico
          .informacaoProjeto(id)
          .then(informacaoProjeto => {
            this.projeto = informacaoProjeto;
          });
      },
      carregarOrgaosFinaciadoresProjeto(id) {
        return transparenciaServico
          .orgaosFinaciadoresProjeto(id)
          .then(orgaosFinaciadoresProjeto => {
            this.orgaosFinaciadoresProjeto = orgaosFinaciadoresProjeto;
          });
      },
      carregarRelatorioAcompanhamentoProjeto(id) {
        this.relatorioAcompanhamentoProjeto = [];
        return transparenciaServico.relatorioAcompanhamentoProjeto(id)
          .then(relatorio => {
            this.relatorioAcompanhamentoProjeto = relatorio;
          })
          .catch(() => {
            this.$swal('', 'Ocorreu um erro ao verificar os relatórios disponíveis, tente novamente.', 'error');
          });
      },
      carregarArquivos(id) {
        transparenciaServico
          .arquivos(id)
          .then(arquivos => {
            this.arquivos = arquivos;
          });
      },
      download(arquivo) {
        transparenciaServico
          .download(this.$route.params.id, this.nomeArquivo(arquivo))
          .then(arquivo => {
            arquivo.download();
          });
      },
      formatarParticipacao(valor) {
        const participacao = parseFloat(valor);

        if (!valor || isNaN(participacao)) {
          return '0,00';
        }
        
        return participacao.toFixed(2).replace('.', ',');
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      gerarRelatorioLancamentos() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_LANCAMENTOS } });
      },
      gerarRelatorioRubricas() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_RUBRICAS } });
      },
      gerarRelatorioPagamentoPessoaFisica() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_PESSOA_FISICA } });
      },
      gerarRelatorioPagamentoPessoaJuridica() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_PESSOA_JURIDICA } });
      },
      gerarRelatorioPagamentoAgente() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_AGENTE } });
      },
      gerarRelatorioPagamentoAluno() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query,  params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_ALUNO } });
      },
      gerarRelatorioPagamentoClt() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query, params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_PAGAMENTO_CLT } });
      },
      gerarRelatorioComprasLicitacoes() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query, params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_COMPRAS_LICITACOES } });
      },
      gerarRelatorioAcompanhamentoProjeto() {
        this.relatorio = null;
        this.$router.push({ name: 'transparencia.projetos.detalhar.lancamento', query: this.$route.query, params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_ACOMPANHAMENTO_PROJETO } });
      },
      voltar() {
        this.$router.push({
          name: 'transparencia.projetos',
          query: this.$route.query
        });
      },
    },
    computed: {
      mostrarAnexosProjeto() {
        const dataAtual = moment(new Date());

        if (
          (!this.projeto.perpetuaClausulaConfidencialLei8958
            && !this.projeto.clausulaConfidencialLei8958) ||
          (this.projeto.perpetuaClausulaConfidencialLei8958
            && !this.projeto.arquivosClausulaConfidencialLei8958) ||
          (this.projeto.clausulaConfidencialLei8958
            && this.projeto.dataLimiteClausulaConfidencialLei8958
            && this.projeto.dataLimiteClausulaConfidencialLei8958 >= dataAtual
            && !this.projeto.arquivosClausulaConfidencialLei8958) ||
          (this.projeto.clausulaConfidencialLei8958
            && this.projeto.dataLimiteClausulaConfidencialLei8958 < dataAtual)
        ) {
          return true;
        }
        return false;
      },
      mostrarRelatorioAcompanhamentoProjeto() {
        let mostrar = false;

        if (this.relatorioAcompanhamentoProjeto.length > 0) {
          mostrar = true;
        }

        return mostrar;
      },
      mostrarRelatorios() {
        let mostrar = false;

        if (this.projeto.transpLancamentos) mostrar = true;
        if (this.projeto.transpPessoaFisica) mostrar = true;
        if (this.projeto.transpPessoaFisicaCLT) mostrar = true;
        if (this.projeto.transpPgtoPessoaJuridica) mostrar = true;
        if (this.projeto.transpAgenteServidorPublico) mostrar = true;
        if (this.projeto.transpAlunos) mostrar = true;
        if (this.projeto.transpRubricas) mostrar = true;
        if (this.projeto.transpComprasLicitacoes) mostrar = true;
        if (this.mostrarRelatorioAcompanhamentoProjeto) mostrar = true;

        return mostrar;
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Portal da transparência`;
      this.carregarProjeto(this.$route.params.id);
      this.carregarOrgaosFinaciadoresProjeto(this.$route.params.id);
      this.carregarRelatorioAcompanhamentoProjeto(this.$route.params.id);
      this.carregarArquivos(this.$route.params.id);
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="row">
              <dl class="col-md-8">
                <dt>Nome do projeto</dt>
                <dd>{{ projeto.nomeProjeto }}</dd>
              </dl>
              <dl class="col-md-4" style="text-align: right;">
                <dt>Valor do projeto (R$)</dt>
                <dd>{{ projeto.volumeTotalRecursos | formatarNumero }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-6">
                <dt>Coordenador</dt>
                <dd>{{ projeto.nomeCoordenador || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Unidade</dt>
                <dd>{{ projeto.unidade || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Departamento</dt>
                <dd>{{ projeto.departamento || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-3">
                <dt>Período de Execução</dt>
                <dd>{{ projeto.dataInicio | formatarData }} - {{ projeto.dataTermino | formatarData }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Período de Vigência</dt>
                <dd>{{ projeto.dataInicioVigencia | formatarData }} - {{ projeto.dataTerminoVigencia | formatarData }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Nº Convênio/Contrato</dt>
                <dd>{{ projeto.nrProcesso || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Nº Processo</dt>
                <dd>{{ projeto.nrProcessoInst || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-md-3">
                <dt>Data de assinatura</dt>
                <dd>{{ (projeto.dataAssinContrato | formatarData) || '---' }}</dd>
              </dl>
              <dl class="col-md-3">
                <dt>Adepto à lei 13.019/2024</dt>
                <dd>{{ projeto.adeptoLei13019 ? ' Sim' : 'Não' }}</dd>
              </dl>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <dt>Órgão Financiador</dt>
                <div class="table-responsive margin-top-5">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Orgão</th>
                        <th>Tipo de órgão</th>
                        <th>Esfera</th>
                        <th>Fonte de recurso</th>
                        <th style="text-align: right;">Participação (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="orgaoFinanciador in orgaosFinaciadoresProjeto">
                        <td>{{ orgaoFinanciador.NomeOrgaoFinanciador }}</td>
                        <td>{{ orgaoFinanciador.TipoOrgaoNome }}</td>
                        <td>{{ orgaoFinanciador.EsferaOrgaoNome }}</td>
                        <td>{{ orgaoFinanciador.FonteRecursoNome }}</td>
                        <td style="text-align: right;">{{ formatarParticipacao(orgaoFinanciador.Participacao) }}</td>
                      </tr>
                      <tr v-if="orgaosFinaciadoresProjeto.length === 0 && !carregando">
                        <td colspan="5" class="text-center">Nenhum orgão financiador registrado.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <dl class="col-xs-12">
                <dt>Objetivo</dt>
                <dd class="white-space-pre">{{ projeto.objetivo || '---' }}</dd>
              </dl>
            </div>

            <div v-if="mostrarRelatorios">
              <div style="border-top: 1px solid #ccc; padding-bottom: 12px;" />
              <div class="row" style="padding-bottom: 6px;">
                <h3 class="col-xs-12"><b>Relatórios</b></h3>
              </div>

              <div class="row">

                <div class="col-md-3 col-tela-grande" v-if="projeto.transpLancamentos">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          data-toggle="tooltip" title="Lançamentos"
                          :class="{'active': tipoRelatorio === RELATORIO_LANCAMENTOS}" @click="gerarRelatorioLancamentos"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Lançamentos
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpRubricas">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_RUBRICAS}" @click="gerarRelatorioRubricas"
                          data-toggle="tooltip" title="Rubricas"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Rubricas
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpPessoaFisica">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_PESSOA_FISICA}"
                          data-toggle="tooltip" title="Pagamento Pessoa Física"
                          @click="gerarRelatorioPagamentoPessoaFisica"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Pessoa Física
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpAgenteServidorPublico">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_AGENTE}"
                          data-toggle="tooltip" title="Pagamento a Agentes e Servidores Públicos"
                          @click="gerarRelatorioPagamentoAgente"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto a Agentes e Servidores Públicos
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpPessoaFisicaCLT">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_CLT}" @click="gerarRelatorioPagamentoClt"
                          data-toggle="tooltip" title="Pagamento Pessoa Física CLT"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Pessoa Física CLT
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpAlunos">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_ALUNO}"
                          @click="gerarRelatorioPagamentoAluno"
                          data-toggle="tooltip" title="Pagamento Alunos"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Alunos
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpPgtoPessoaJuridica">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_PESSOA_JURIDICA}"
                          @click="gerarRelatorioPagamentoPessoaJuridica"
                          data-toggle="tooltip" title="Pagamento Pessoa Jurídica"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Pgto Pessoa Jurídica
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="projeto.transpComprasLicitacoes">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_PAGAMENTO_PESSOA_JURIDICA}"
                          @click="gerarRelatorioComprasLicitacoes"
                          data-toggle="tooltip" title="Compras/Licitações"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Compras/Licitações
                  </button>
                </div>
                <div class="col-md-3 col-tela-grande" v-if="mostrarRelatorioAcompanhamentoProjeto">
                  <button class="btn btn-block btn-primary botao-relatorio"
                          :class="{'active': tipoRelatorio === RELATORIO_ACOMPANHAMENTO_PROJETO}"
                          @click="gerarRelatorioAcompanhamentoProjeto"
                          data-toggle="tooltip" title="Acompanhamento Projeto"
                          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando...">
                    <i class="fa fa-bank"></i> Acompanhamento Projeto
                  </button>
                </div>
              </div>
            </div>

            <div v-if="mostrarAnexosProjeto">
              <div style="border-top: 1px solid #ccc; padding-bottom: 12px;" />
              <div class="row" style="padding-bottom: 6px;">
                <h3 class="col-xs-12"><b>Anexos do projeto</b></h3>
              </div>

              <div class="row" style="padding-bottom: 6px;">
                <div class="col-xs-12">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Documento</th>
                          <th>Visualizar/Download</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="arquivo in arquivos">
                          <td>{{ nomeArquivo(arquivo) }}</td>
                          <td class="action">
                            <button type="button"
                                    class="btn btn-default btn-xs"
                                    @click="download(arquivo)">
                              <i class="fa fa-download"></i>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="arquivos.length === 0 && !carregando">
                          <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12 flex-container" style="justify-content:end; margin-bottom:25px">
        <button class="btn btn-primary"
                @click="voltar">
          <i class="fa fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
  </div>
</template>
<style>
.botao-relatorio{
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 1500px) {
  .col-tela-grande {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/DetalharProjeto.vue